import React from "react";
import { Button } from "@mui/material";
import * as XLSX from "xlsx";
import { commonCss } from "../../StyleConfig/CommonCss";

const ExportExcel = ({ columns, data, dashboardData }) => {
  const handleExport = () => {
    // Prepare table headers
    const headers = columns.map((col) => col.Header);

    // Prepare table rows
    const tableRows = data.map((row) =>
      columns.map((col) => {
        let value = row[col.accessor];
        if (col.Cell) {
          value = col.Cell({ value, cell: { row: { original: row } } });
        }
        return value ?? "";
      })
    );

    // Footer rows
    const footerInfo = [
      [], // empty row after table
      ["Total Hours", dashboardData?.totalDurationText ?? ""],
      ["Total Man Days", dashboardData?.manDays ?? ""],
    ];

    // Build worksheet data (headers + rows + footer)
    const worksheetData = [headers, ...tableRows, ...footerInfo];

    // Create worksheet & workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export to Excel
    XLSX.writeFile(workbook, "table_export.xlsx");
  };

  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "rgb(0, 86, 151)",
        borderRadius: commonCss.buttonBorderRadius,
        textTransform: "none",
        padding: "0.6rem 1rem",
        color: commonCss.buttonTextColor,
        width: "15vw",
      }}
      onClick={handleExport}
    >
      Export
    </Button>
  );
};

export default ExportExcel;




